(function ($, window, document) {
    'use strict';

    const widgetSelector = '.carte-interactive-marches-publics';
    const dataSelector = '.carte-interactive__data';
    const mapSelector = '[data-carte-interactive-map]';
    const noResults = '<li class="no-result">Aucun résultat ne correspond à votre&nbsp;recherche.</li>';
    const monthsMap = {
        janvier: 1,
        fevrier: 2,
        mars: 3,
        avril: 4,
        mai: 5,
        juin: 6,
        juillet: 7,
        aout: 8,
        septembre: 9,
        octobre: 10,
        novembre: 11,
        decembre: 12,
    };
    let elementorHookRegistered = false;

    function ready(callback) {
        if (document.readyState !== 'loading') {
            callback();
            return;
        }

        document.addEventListener('DOMContentLoaded', callback);
    }

    function normalizeText(value) {
        value = value == null ? '' : String(value);

        if (typeof value.normalize === 'function') {
            value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }

        return value.toLowerCase().trim();
    }

    function escapeHtml(value) {
        return $('<div />').text(value == null ? '' : value).html();
    }

    function getRoots(context) {
        const scope = context || document;
        const roots = [];

        if (scope.matches && scope.matches(widgetSelector)) {
            roots.push(scope);
        }

        if (scope.querySelectorAll) {
            roots.push.apply(roots, Array.prototype.slice.call(scope.querySelectorAll(widgetSelector)));
        }

        return roots;
    }

    function parseMarkets(root) {
        const dataElement = root.querySelector(dataSelector);

        if (!dataElement) {
            return [];
        }

        try {
            return JSON.parse(dataElement.textContent || '[]');
        } catch (error) {
            window.console.error('Impossible de lire les données de la carte interactive.', error);
            return [];
        }
    }

    function prepareMarkets(markets) {
        return markets.map(function (market) {
            const services = Array.isArray(market.services) ? market.services : [];
            const openMonths = Array.isArray(market.openMonths) ? market.openMonths : [];
            const openDays = Array.isArray(market.openDays) ? market.openDays : [];
            const searchText = [
                market.title,
                market.name,
                market.displayTitle,
                market.holidayTitle,
                market.regionTitle,
                market.municipalite,
            ].join(' ');

            market.searchText = normalizeText(searchText);
            market.serviceSet = new Set(services);
            market.openMonthsSet = new Set(openMonths.map(Number));
            market.openDaysSet = new Set(openDays.map(normalizeText));

            return market;
        });
    }

    function getMonthNumber(month) {
        return monthsMap[normalizeText(month)] || null;
    }

    function buildInfoWindowContent(market, isHolidayMap) {
        const membership = market.membership || 'nonMember';
        const title = isHolidayMap
            ? (market.holidayTitle || market.displayTitle || market.title)
            : (market.name || market.title);

        if (membership === 'nonMember') {
            return '<div class="single-marche-public nonMember"><div class="infos"><h6>' + escapeHtml(title) + '</h6><p>Ce marché n\'est pas membre de l\'Association des marchés publics du Québec</p></div></div>';
        }

        const image = isHolidayMap
            ? (market.holidayImage || market.image)
            : (market.infoImage || market.image);

        return '<div class="single-marche-public ' + escapeHtml(membership) + '"><a href="' + escapeHtml(market.url) + '"><div class="image"><img src="' + escapeHtml(image) + '" alt="Image du marche"></div><div class="infos"><h6>' + escapeHtml(title) + '</h6></div></a></div>';
    }

    async function getMapsApi() {
        if (!window.google || !window.google.maps) {
            return null;
        }

        let mapsLibrary = {};
        let markerLibrary = {};
        let coreLibrary = {};

        if (typeof window.google.maps.importLibrary === 'function') {
            [
                mapsLibrary,
                markerLibrary,
                coreLibrary,
            ] = await Promise.all([
                window.google.maps.importLibrary('maps'),
                window.google.maps.importLibrary('marker'),
                window.google.maps.importLibrary('core'),
            ]);
        }

        const mapsApi = {
            ControlPosition: window.google.maps.ControlPosition || coreLibrary.ControlPosition || mapsLibrary.ControlPosition,
            event: window.google.maps.event,
            InfoWindow: window.google.maps.InfoWindow || mapsLibrary.InfoWindow,
            LatLng: window.google.maps.LatLng || coreLibrary.LatLng,
            LatLngBounds: window.google.maps.LatLngBounds || coreLibrary.LatLngBounds,
            Map: window.google.maps.Map || mapsLibrary.Map,
            Marker: window.google.maps.Marker || markerLibrary.Marker,
        };

        if (typeof mapsApi.Map !== 'function') {
            window.console.error('La librairie Google Maps "maps" n’est pas disponible.');
            return null;
        }

        if (typeof mapsApi.Marker !== 'function') {
            window.console.error('La librairie Google Maps "marker" n’est pas disponible.');
            return null;
        }

        return mapsApi;
    }

    async function initRoot(root) {
        if (
            root.dataset.carteInteractiveInitialized === '1'
            || root.dataset.carteInteractiveInitializing === '1'
        ) {
            return;
        }

        if (!window.google || !window.google.maps) {
            return;
        }

        const mapElement = root.querySelector(mapSelector);
        const marketList = root.querySelector('#marche-public-list');

        if (!mapElement || !marketList) {
            return;
        }

        root.dataset.carteInteractiveInitializing = '1';
        const mapsApi = await getMapsApi();

        if (!mapsApi) {
            delete root.dataset.carteInteractiveInitializing;
            return;
        }

        root.dataset.carteInteractiveInitialized = '1';
        delete root.dataset.carteInteractiveInitializing;

        const markets = parseMarkets(root);
        const preparedMarkets = prepareMarkets(markets);
        const isHolidayMap = root.dataset.isHolidayMap === '1';
        const stylesheetDirectoryUri = (root.dataset.stylesheetDirectoryUri || '').replace(/\/$/, '');
        const iconBase = stylesheetDirectoryUri + '/dist/images/';
        const holidayMarker = iconBase + 'holiday-market-marker.png';
        const membershipMarker = {
            member: iconBase + 'member-marker.png',
            nonMember: iconBase + 'non-member-marker.png',
        };
        const markerList = {};
        const listItems = {};
        const $root = $(root);
        const $marketSearch = $root.find('#marketSearch');
        const $regionFilters = $root.find('.region-filter');
        const $monthFilter = $root.find('#mois-ouverture');
        const $coveredFilter = $root.find('#couvert');
        const $holidayFilter = $root.find('#holidayMarket');

        let centerPos = null;
        let centering = false;
        let currentMarker = null;
        let zoomChangeBoundsListener = null;
        let debounceSearch = null;

        $root.find('.single-marche-public-result').each(function () {
            const slug = this.dataset.marketSlug || this.getAttribute('rel');

            if (slug) {
                listItems[slug] = this;
            }
        });

        const mapOptions = {
            center: { lat: 46.8139, lng: -71.2080 },
            zoom: 5,
            mapId: 'DEMO_MAP_ID',
            disableDefaultUI: true,
            zoomControl: true,
            fullscreenControl: false,
        };

        if (
            mapsApi.ControlPosition
            && mapsApi.ControlPosition.LEFT_CENTER !== undefined
        ) {
            mapOptions.zoomControlOptions = {
                position: mapsApi.ControlPosition.LEFT_CENTER,
            };
        }

        const map = new mapsApi.Map(mapElement, mapOptions);
        const infoWindow = new mapsApi.InfoWindow();

        infoWindow.addListener('closeclick', function () {
            if (currentMarker) {
                currentMarker.open = false;
                currentMarker = null;
            }
        });

        mapsApi.event.addListener(map, 'zoom_changed', function () {
            zoomChangeBoundsListener = mapsApi.event.addListener(map, 'bounds_changed', function () {
                if (!centering && this.getZoom() < 5.3 && this.initialZoom === true) {
                    this.setZoom(5.3);
                    this.initialZoom = false;

                    if (centerPos != null) {
                        map.setCenter(new mapsApi.LatLng(centerPos.lat, centerPos.lng));
                        map.setZoom(11);
                    }
                }

                mapsApi.event.removeListener(zoomChangeBoundsListener);
            });
        });
        map.initialZoom = true;

        function addMarker(market) {
            const markerIcon = isHolidayMap && market.isHolidayMarket
                ? holidayMarker
                : (membershipMarker[market.membership] || membershipMarker.nonMember);
            const marker = new mapsApi.Marker({
                position: new mapsApi.LatLng(Number(market.lat), Number(market.lng)),
                map,
                title: market.displayTitle || market.title,
                icon: markerIcon,
            });

            marker.open = false;
            markerList[market.slug] = marker;

            mapsApi.event.addListener(marker, 'click', function () {
                toggleInfoWindow(marker, market);
            });
        }

        function toggleInfoWindow(marker, market) {
            if (currentMarker === marker && marker.open) {
                infoWindow.close();
                marker.open = false;
                currentMarker = null;
                return;
            }

            if (currentMarker) {
                currentMarker.open = false;
            }

            infoWindow.setContent(buildInfoWindowContent(market, isHolidayMap));
            infoWindow.open({ anchor: marker, map, shouldFocus: false });
            marker.open = true;
            currentMarker = marker;

            centering = true;
            map.setZoom(16);
            map.panTo(marker.getPosition());
            map.panBy(200, -100);

            setTimeout(function () {
                centering = false;
            }, 1000);
        }

        function handleLocationError(browserHasGeolocation, infoWindowInstance, pos) {
            infoWindowInstance.setPosition(pos);
            infoWindowInstance.setContent(
                browserHasGeolocation
                    ? 'Error: The Geolocation service failed.'
                    : 'Error: Your browser doesn\'t support geolocation.'
            );
            infoWindowInstance.open(map);
        }

        function getCheckedValues(selector, normalizer) {
            const values = [];

            $root.find(selector).each(function () {
                const value = normalizer ? normalizer(this.value) : this.value;

                if (value) {
                    values.push(value);
                }
            });

            return values;
        }

        function getActiveFilters() {
            const search = normalizeText($marketSearch.val());
            const region = $regionFilters.first().val() || 'all';
            const month = getMonthNumber($monthFilter.val());
            const days = getCheckedValues('.advanced-filters-container .weekdays input:checked', normalizeText);
            const services = getCheckedValues('.advanced-filters-container .services input:checked');
            const covered = $coveredFilter.is(':checked');
            const holiday = $holidayFilter.is(':checked');

            return {
                search,
                region,
                month,
                days,
                services,
                covered,
                holiday,
                active: Boolean(search || region !== 'all' || month || days.length || services.length || covered || holiday),
            };
        }

        function matchesFilters(market, filters) {
            if (filters.search && market.searchText.indexOf(filters.search) === -1) {
                return false;
            }

            if (filters.region !== 'all' && market.regionSlug !== filters.region) {
                return false;
            }

            if (filters.month && !market.openMonthsSet.has(filters.month)) {
                return false;
            }

            if (filters.days.length && !filters.days.some(function (day) {
                return market.openDaysSet.has(day);
            })) {
                return false;
            }

            if (filters.services.length && !filters.services.some(function (service) {
                return market.serviceSet.has(service);
            })) {
                return false;
            }

            if (filters.covered && !market.isCovered) {
                return false;
            }

            return !(filters.holiday && !market.isHolidayMarket);
        }

        function setMarketVisibility(slug, isVisible) {
            const listItem = listItems[slug];

            if (!listItem) {
                return;
            }

            listItem.style.display = isVisible ? '' : 'none';
            listItem.classList.toggle('show', isVisible);
        }

        function updateNoResults(found) {
            const noResult = marketList.querySelector('.no-result');

            if (!found && !noResult) {
                marketList.insertAdjacentHTML('beforeend', noResults);
            } else if (found && noResult) {
                noResult.remove();
            }
        }

        function fitMapToBounds(bounds, markerCount) {
            if (!markerCount) {
                return;
            }

            if (markerCount === 1) {
                map.setCenter(bounds.getCenter());
                map.setZoom(11);
                return;
            }

            map.fitBounds(bounds);
        }

        function fitMapToMarkers(markers) {
            const bounds = new mapsApi.LatLngBounds();

            markers.forEach(function (marker) {
                bounds.extend(marker.getPosition());
            });

            fitMapToBounds(bounds, markers.length);
        }

        function createClusterer(markers) {
            if (
                window.markerClusterer
                && typeof window.markerClusterer.MarkerClusterer === 'function'
            ) {
                return new window.markerClusterer.MarkerClusterer({ map, markers });
            }

            window.console.warn('MarkerClusterer est absent; la carte interactive fonctionne sans clustering.');
            return null;
        }

        function syncClusterMarkers(clusterer, visibleMarkers) {
            const allMarkers = Object.values(markerList);

            if (!clusterer) {
                allMarkers.forEach(function (marker) {
                    marker.setMap(visibleMarkers.indexOf(marker) === -1 ? null : map);
                });
                return;
            }

            if (typeof clusterer.clearMarkers === 'function') {
                clusterer.clearMarkers();
            } else if (typeof clusterer.removeMarker === 'function') {
                allMarkers.forEach(function (marker) {
                    clusterer.removeMarker(marker);
                });
            }

            allMarkers.forEach(function (marker) {
                if (visibleMarkers.indexOf(marker) === -1) {
                    marker.setMap(null);
                }
            });

            if (!visibleMarkers.length) {
                return;
            }

            if (typeof clusterer.addMarkers === 'function') {
                clusterer.addMarkers(visibleMarkers);
                return;
            }

            visibleMarkers.forEach(function (marker) {
                marker.setMap(map);
                clusterer.addMarker(marker);
            });
        }

        preparedMarkets.forEach(function (market) {
            if (!market.hasLocation || market.lat === null || market.lng === null) {
                return;
            }

            addMarker(market);
        });

        const allMarkers = Object.values(markerList);
        const clusterer = createClusterer(allMarkers);
        fitMapToMarkers(allMarkers);

        function filterItems() {
            const filters = getActiveFilters();
            const bounds = new mapsApi.LatLngBounds();
            const visibleMarkers = [];
            let found = false;

            preparedMarkets.forEach(function (market) {
                const isShown = matchesFilters(market, filters);
                const marker = markerList[market.slug];

                setMarketVisibility(market.slug, isShown);

                if (!isShown) {
                    return;
                }

                found = true;

                if (marker) {
                    visibleMarkers.push(marker);
                    bounds.extend(marker.getPosition());
                }
            });

            updateNoResults(found);
            syncClusterMarkers(clusterer, visibleMarkers);

            if (currentMarker && visibleMarkers.indexOf(currentMarker) === -1) {
                infoWindow.close();
                currentMarker.open = false;
                currentMarker = null;
            }

            if (!filters.active && centerPos != null) {
                map.setCenter(new mapsApi.LatLng(centerPos.lat, centerPos.lng));
                map.setZoom(11);
                return;
            }

            fitMapToBounds(bounds, visibleMarkers.length);
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    centerPos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    map.setCenter(centerPos);

                    new mapsApi.Marker({
                        position: centerPos,
                        map,
                        title: '',
                        icon: iconBase + 'current-location-marker.svg',
                    });
                },
                function () {
                    handleLocationError(true, infoWindow, map.getCenter());
                }
            );
        }

        $marketSearch.on('input', function () {
            clearTimeout(debounceSearch);
            debounceSearch = setTimeout(filterItems, 300);
        });

        $root.find('.advanced-filters-container .checkboxBtn input').on('change', function () {
            $(this).closest('.checkboxBtn').toggleClass('active', this.checked);
        });

        $root.find('#reinitaliserFiltre').on('click', function () {
            $marketSearch.val('');
            $root.find('.advanced-filters-container input:checkbox').prop('checked', false);
            $root.find('.advanced-filters-container select').prop('selectedIndex', 0);
            $root.find('.advanced-filters-container label').removeClass('active');
            $regionFilters.val('all');
            filterItems();
        });

        $root.find('.advanced-filters-container input[type="submit"]').on('click', function (e) {
            e.preventDefault();
            $root.find('.advanced-filters-container').fadeOut(350);
            filterItems();
        });

        $regionFilters.on('change', function () {
            const region = $(this).val();
            $regionFilters.val(region);
            filterItems();
        });

        $root.find('.single-marche-public-result').on('click', function () {
            const slug = this.dataset.marketSlug || this.getAttribute('rel');
            const marker = markerList[slug];

            if (marker) {
                mapsApi.event.trigger(marker, 'click');
            }
        });

        $(window).on('resize.carteInteractive', function () {
            mapsApi.event.trigger(map, 'resize');
        });
        mapsApi.event.trigger(map, 'resize');

        $root.find('.advanced-filters').on('click', function (e) {
            e.stopPropagation();
            $root.find('.advanced-filters-container').fadeToggle(350);
        });
    }

    function initAll(context) {
        ready(function () {
            if (!window.google || !window.google.maps) {
                return;
            }

            getRoots(context).forEach(function (root) {
                initRoot(root).catch(function (error) {
                    delete root.dataset.carteInteractiveInitializing;
                    window.console.error('Erreur pendant l’initialisation de la carte interactive.', error);
                });
            });
        });
    }

    function registerElementorHook() {
        if (elementorHookRegistered) {
            return;
        }

        if (!window.elementorFrontend || !window.elementorFrontend.hooks) {
            return;
        }

        elementorHookRegistered = true;
        window.elementorFrontend.hooks.addAction('frontend/element_ready/carte-interactive.default', function ($scope) {
            initAll($scope && $scope[0] ? $scope[0] : document);
        });
    }

    window.CustomElementCarteInteractive = window.CustomElementCarteInteractive || {};
    window.CustomElementCarteInteractive.initAll = initAll;
    window.customElementCarteInteractiveInit = initAll;

    if (window.google && window.google.maps) {
        initAll();
    }

    registerElementorHook();
    $(window).on('elementor/frontend/init', registerElementorHook);
})(jQuery, window, document);
